import { AiGeneratorOutputFormat } from '../../../types';

export interface ComposableBlock {
  label: string;
  output: string;
}

/**
 * The field's final submitted value, built from its blocks. Blocks with no
 * output yet (not generated, or generation failed) are left out, so a
 * half-finished field doesn't submit empty headers or `""` JSON entries.
 */
export const composeOutput = (
  blocks: ComposableBlock[],
  format: AiGeneratorOutputFormat = 'markdown',
): string => {
  const filled = blocks.filter((block) => block.output.trim() !== '');
  if (filled.length === 0) return '';

  switch (format) {
    case 'json':
      return JSON.stringify(filled.map(({ label, output }) => ({ label, output })));
    case 'blocks-only':
      return filled.map((block) => block.output.trim()).join('\n\n');
    case 'markdown':
    default:
      return filled.map((block) => `## ${block.label}\n\n${block.output.trim()}`).join('\n\n');
  }
};
